// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1URa1","index":"styles_index__1TncI"};